import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import ReactPlayer from "react-player";
import useFileHandleS3 from "../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../Screen/MediaUploadProgressBar";

const SouvenirCreateStar = () => {
  const history = useHistory();

  const [description, setDescription] = useState();
  const [instruction, setInstruction] = useState();
  const [title, setTitle] = useState();
  const [price, setPrice] = useState();
  const [tax, setTax] = useState();
  const [banner, setBanner] = useState();
  const [video, setVideo] = useState();
  const [errorList, setError] = useState([]);
  const [showFile, setShowFile] = useState("");
  const [showFileVideo, setShowFileVideo] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDescription("");
    setInstruction("");
    setTitle("");
    setPrice("");
    setTax("");
    setBanner("");
    setVideo("");
  }, []);
  // File Handle
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'souvenir/images',delKey);

  const handleImageChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const actionSouviner = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("description", description);
    formData.append("instruction", instruction);
    formData.append("title", title);
    formData.append("price", price);
    formData.append("tax", tax);
    formData.append("banner", fileKey);
    // formData.append("video", video);

    axios.post(`/api/star/souviner/store`, formData).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        setDescription("");
        setInstruction("");
        setTitle("");
        setPrice("");
        setTax("");
        // setVideo("");

        setError([]);
        swal("Welcome", res.data.message, "success");

        history.push("/superstar/souvenir");
      } else {
        setError(res.data.validation_errors);

        // error_list: res.data.validation_errors,
      }
    });
  };

  return (
    <div className="">
      <div className="text-light d-flex border border-warning rounded-3 align-items-center justify-content-center p-2 mb-3">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus mx-2"></i>
        </div>
        <h3 className="text-warning text-bold">Create Default Souvenir</h3>
      </div>
      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form id="input_form" onSubmit={actionSouviner}>
                  <div className="row my-4">
                    <div className="col-sm-3 label-text">
                      <p>Title</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        name="title"
                        value={title}
                        placeholder="Enter title"
                        onChange={(event) => {
                          setTitle(event.target.value);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.title}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-sm-3 label-text">
                      <p>Description</p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data=""
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setDescription(editor.getData());
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.description}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-sm-3 label-text">
                      <p>Instruction</p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data=""
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setInstruction(editor.getData());
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.instruction}
                      </span>
                    </div>
                  </div>

                  <div className="row my-1 ">
                    <div className="col-sm-3 label-text">
                      <p>Banner</p>
                    </div>
                    <div className="col-md-5">
                      {fileUrl ? (
                        <img
                          src={fileUrl}
                          alt="..."
                          className="demo-preview-image img-fluid"
                          style={{
                            borderRadius: "23px",
                            height: "200px",
                            width: "300px",
                          }}
                        />
                      ) : (
                        ""
                      )}

                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(e) => handleImageChange(e.target.files)}
                      />
                      {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <span className="text-danger buTon-abc">
                        {errorList.banner}
                      </span>
                    </div>
                  </div>
                  {/* <div className="row my-1 ">
                    <div className="col-sm-3 label-text">
                      <p className="">Video</p>
                    </div>
                    <div className="col-md-5">
                      {showFileVideo ? (
                        <ReactPlayer
                          url={showFileVideo}
                          playing={true}
                          volume={1}
                          width="300px"
                          height="200px"
                        />
                      ) : (
                        ""
                      )}
                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(event) => {
                          setVideo(event.target.files[0]);
                          setShowFileVideo(
                            URL.createObjectURL(event.target.files[0])
                          );
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.video}
                      </span>
                    </div>
                  </div> */}
                  <div className="row  ">
                    <div className="col-sm-3 label-text">
                      <p>Cost</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        name="cost"
                        placeholder="Enter fee $"
                        value={price}
                        onChange={(event) => {
                          setPrice(event.target.value);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.price}
                      </span>
                    </div>
                  </div>

                  <div className="row  ">
                    <div className="col-sm-3 label-text">
                      <p>Tax</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        name="tax"
                        placeholder="Enter tax"
                        value={tax}
                        onChange={(event) => {
                          setTax(event.target.value);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.tax}
                      </span>
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SouvenirCreateStar;
